export default __webpack_public_path__ + "static/media/coach-bundle_white@3x.f2bccd2e.webp";